import { useState, useEffect } from "react";

import SalesHeader from "../../components/Sales/SalesHeader";
import StatusDetails from "../../components/Sales/StatusDetails";
import SalesTabs from "../../components/Sales/SalesTabs";

import SalesTable from "../../components/Sales/Tablesss/SalesTable";
import SnakeTable from "../../components/Sales/Tablesss/SnakeTable";
import BackgroundTable from "../../components/Sales/Tablesss/BackgroundTable";
import PowerupTable from "../../components/Sales/Tablesss/PowerupTable";

import { getSalesStats } from "../../api/salesApi";

import "./SalesInventory.css";

export default function SalesDashboard() {
  const [activeView, setActiveView] = useState("sales");
  const [selectedFilter, setSelectedFilter] = useState("All");
  const [searchText, setSearchText] = useState("");

  const [statsData, setStatsData] = useState({});

  const fetchSalesStats = async () => {
    try {
      const res = await getSalesStats();
      console.log("get sales stats:", res);
      setStatsData(res?.data || {});
      console.log(
        "stats:fghjkhg",
        res.data,
        res.data.totalSoldItems,
        res.data.totalRevenue?.[0].totalRevenue,
      );
    } catch (error) {
      console.error("error on get sales stats:", error);
    }
  };

  useEffect(() => {
    fetchSalesStats();
  }, []);

  const handleViewChange = (view) => {
    setActiveView(view);
    setSelectedFilter("All");
    setSearchText("");
  };

  const renderTable = () => {
    const commonProps = { searchText, selectedFilter };

    switch (activeView) {
      case "snake":
        return <SnakeTable {...commonProps} />;
      case "background":
        return <BackgroundTable {...commonProps} />;
      case "powerup":
        return <PowerupTable {...commonProps} />;
      default:
        return <SalesTable />;
    }
  };

  return (
    <div className="sales-dashboard">
      <div className="sales-main">
        <SalesHeader
          activeView={activeView}
          selectedFilter={selectedFilter}
          onFilterChange={setSelectedFilter}
          onViewChange={handleViewChange}
          searchText={searchText}
          onSearchChange={setSearchText}
        />

        <div className="sales-content-wrapper">
          <div className="sales-inner-wrapper">
            <div className="stats-wrapper">
              <StatusDetails data={statsData} />
            </div>

            {activeView !== "sales" && (
              <SalesTabs
                activeTab={activeView}
                onTabChange={handleViewChange}
              />
            )}

            <div className="table-wrapper">{renderTable()}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
